import React from 'react';
import { Route, IndexRoute, IndexRedirect } from 'react-router';
import moment from 'moment';
import { t } from '../i18n';
import {
  IsAnonymous,
  IsLoggedIn,
  LoginWrapper,
  IsAdmin,
  IsUser,
  IsDebtor,
  IsCreditor,
  IsExecutor,
  IsCallCentrum,
  IsAdminOrOperator,
  IsVerified,
} from '../../features/auth/utils';
import App from '../../app/containers/App';
import {
  LoginContainer,
  ForgottenPasswordContainer,
  ResetPasswordContainer,
  AccountActivationContainer,
} from '../../features/auth/containers';
import NotFound from '../../features/not-found/NotFound';
import { AdminWrapper } from '../../features/admin/containers';
import { DashboardWrapper, DashboardIndexContainer } from '../../features/dashboard/containers';
import { AdminDashboardContainer } from '../../features/admin-dashboard/containers';
import { MessagingDashboardContainer, EmailLogDetailContainer } from '../../features/messaging-dashboard/containers';
import {
  AllocationsContainer,
  CreateAllocationContainer,
  CreateManualAllocationContainer,
  CreateAutomaticAllocationContainer
} from '../../features/allocations/containers';
import { DisposalsContainer } from '../../features/disposals/containers';
import { LoansContainer } from '../../features/loans/containers';
import { DocumentsContainer } from '../../features/documents/containers';
import { UserProfileContainer } from '../../features/user-profile/containers';
import { UserSettingsContainer } from '../../features/user-settings/containers';
import { LandingPageContainer } from '../../features/landing-page/containers';
import {
  AccountListContainer,
  AccountProfileContainer,
  AccountDetailContainer,
  AccountDetailWrapper,
  AccountDocumentsContainer,
  AccountLoansContainer,
  AccountAllocationsContainer,
  AccountMessageContainer,
  AccountExportsContainer,
} from '../../features/account-management/containers';
import {
  AdministratorListContainer,
  AdministratorCreateContainer,
} from '../../features/administrator-management/containers';
import { LoanListContainer, LoanDetailContainer, DisposeLoanListContainer } from '../../features/loan-management/containers';
import { EncashmentStatus } from '../../features/loan-management/components'
import {
  AllocationListContainer,
  AllocationDetailContainer,
} from '../../features/allocation-management/containers';
import {
  PaymentListContainer,
  PaymentDetailContainer,
} from '../../features/payment-management/containers';
import {
  SettingListContainer,
  SettingDetailContainer,
} from '../../features/setting-management/containers';
import {
  OnboardingCreditorContainer,
  OnboardingDebtorContainer,
} from '../../features/onboarding/containers';
import {
  CalculatorDebtorContainer,
  CalculatorCreditorContainer,
} from '../../features/calculator/containers';
import { WithdrawFundsContainer } from '../../features/payments/containers';
import { InvestorPayment } from '../../features/allocations/components';
import {
  Vyhody,
  AkoToFungujeDebtor,
  AkoToFungujeCreditor,
  MailCardPayment
} from '../../features/pages';
import { Exports } from '../../features/admin/components';
import { PomocContainer, InfoCreditorContainer, InfoDebtorContainer } from '../../features/pages/containers';
import { QuestionsContainer, QuestionDetailContainer } from '../../features/help-management/containers';
import { CallCentrumContainer, CallCentrumLandingContainer } from '../../features/call-centrum/containers';
import { AccountOverviewConntainer } from '../../features/overview/containers'
import { selectIsLoggedIn } from '../../features/auth/ducks';
import { logout } from '../../features/auth/ducks';
import IsCreditorOrExecutor from '../../features/auth/utils/IsCreditorOrExecutor';
import {
  PendingTransactionsContainer,
  TransactionsContainer,
  TransactionsPreviewContainer,
  ReportTransactionsContainer
} from '../../features/transactions/containers';
import {
  HandleFileDownloadContainer
} from '../../features/files/containers'
import { ProvisionFeeWithdraw } from '../../features/admin/components';
import { NotificationSignOutContainer } from '../../features/signout-notifications/containers';

const onUserNavigate = (store) => (prevState, nextState) => {
  const state = store.getState();
  if (selectIsLoggedIn(state)) {
    const dateLast = localStorage.getItem('time');
    if (moment(dateLast).isBefore(moment().subtract(1, 'hour'))) {
      localStorage.removeItem('time');
      if (nextState) {
        if (nextState.location) {
          store.dispatch(logout({
            redirect: `?redirect=${encodeURIComponent(nextState.location ? nextState.location.pathname : '/')}`,
            message: t('Boli ste odhlásený z dôvodu dlhej neaktivity.'),
          }));
        }
        else {
          console.log('prev state used')
          store.dispatch(logout());
        }
      }
    } else {
      localStorage.setItem('time', moment().toISOString());
    }
  } else {
    localStorage.removeItem('time');
  }
}

const AdminGuard = IsAdmin((props) => React.cloneElement(props.children, props));
const CallCentrumGuard = IsCallCentrum((props) => React.cloneElement(props.children, props));

export default (store) => (
  <Route path="/" component={App} onEnter={onUserNavigate(store)} onChange={onUserNavigate(store)}>
    <IndexRoute component={IsAnonymous(LandingPageContainer)} />
    {/* <IndexRedirect to="/auth/login" /> */}

    <Route path="/vyhody" component={Vyhody} />
    {/* <Route path="/kontakt" component={Kontakt} /> */}
    <Route path="/ako-si-pozicat" component={AkoToFungujeDebtor} />
    <Route path="/ako-investovat" component={AkoToFungujeCreditor} />
    {/* <Route path="/reklamacny-poriadok" component={ReklamacnyPoriadok} />
    <Route path="/ochrana-osobnych-udajov" component={OchranaOsobnychUdajov} />
    <Route path="/dokumenty-na-stiahnutie" component={DokumentyNaStiahnutie} />
    <Route path="/faq" component={Faq} />
    <Route path="/cennik" component={Cennik} /> */}
    <Route path="/pomoc" component={PomocContainer} />
    <Route path="/info-debtor" component={InfoDebtorContainer} />
    <Route path="/info-creditor" component={InfoCreditorContainer} />
    <Route path="/cardPayment" component={MailCardPayment} />
    <Route path="onboarding">
      <Route path="debtor">
        <IndexRoute component={IsAnonymous(CalculatorDebtorContainer)} />
        <Route path=":step" component={IsAnonymous(OnboardingDebtorContainer)} />
      </Route>
      <Route path="creditor">
        <IndexRoute component={IsAnonymous(CalculatorCreditorContainer)} />
        <Route path="sign-up" component={IsAnonymous(OnboardingCreditorContainer)} />
      </Route>
    </Route>

    <Route path="auth">
      <IndexRedirect to="login" />
      <Route path="login" component={LoginWrapper(LoginContainer)} />
      <Route path="forgotten-password" component={IsAnonymous(ForgottenPasswordContainer)} />
      <Route
        path="reset-password/:passwordResetToken"
        component={IsAnonymous(ResetPasswordContainer)}
      />
      <Route path="activate/:accountId/:activationToken" component={AccountActivationContainer} />
    </Route>

    <Route path="dashboard" component={IsUser(IsLoggedIn(DashboardWrapper))}>
      <IndexRoute component={DashboardIndexContainer} />
      <Route path="loans" component={IsDebtor(IsVerified(LoansContainer))} />
      <Route path="create-loan" component={IsDebtor(CalculatorDebtorContainer)} />
      <Route path="investments" component={IsCreditor(AllocationsContainer)} />
      <Route path="create-investment" component={IsCreditor(CreateAllocationContainer)} />
      <Route path="disposals" component={IsExecutor(DisposalsContainer)} />
      <Route
        path="create-investment/automatic"
        component={IsCreditor(CreateAutomaticAllocationContainer)}
      />
      <Route
        path="create-investment/manual"
        component={IsCreditor(CreateManualAllocationContainer)}
      />
      <Route path="documents" component={DocumentsContainer} />
      <Route path="personal-info" component={UserProfileContainer} />
      <Route path="settings" component={UserSettingsContainer} />
      <Route path="withdraw-funds" component={IsCreditorOrExecutor(WithdrawFundsContainer)} />
      <Route path="exportInvestorPayments" component={IsCreditor(InvestorPayment)} />
      <Route path="transactions" component={TransactionsPreviewContainer} />
      <Route path="overview" component={IsCreditor(AccountOverviewConntainer)} />
    </Route>

    <Route path="admin" component={IsAdminOrOperator(IsLoggedIn(AdminWrapper))}>
      <IndexRedirect to="accounts" />
      <Route path="dashboard">
        <IndexRoute component={AdminDashboardContainer} />
      </Route>
      <Route path="accounts">
        <IndexRoute component={AccountListContainer} />
        <Route path=":accountId" component={AccountDetailWrapper}>
          <IndexRoute component={AccountDetailContainer} />
          <Route path="profile" component={AccountProfileContainer} />
          <Route path="loans" component={AccountLoansContainer} />
          <Route path="allocations" component={AccountAllocationsContainer} />
          <Route path="documents" component={AccountDocumentsContainer} />
          <Route path="messages" component={AccountMessageContainer} />
          <Route path="exports" component={AccountExportsContainer} />
        </Route>
      </Route>
      <Route path="loans">
        <IndexRoute component={LoanListContainer} />
        <Route path=":loanId" component={LoanDetailContainer} />
      </Route>
      <Route path="allocations">
        <IndexRoute component={AllocationListContainer} />
        <Route path=":allocationId" component={AllocationDetailContainer} />
      </Route>
      <Route path="dispose">
        <IndexRoute component={DisposeLoanListContainer} />
        <Route path=":loanId" component={LoanDetailContainer} />
      </Route>
      <Route path="payments">
        <IndexRoute component={PaymentListContainer} />
        <Route path=":paymentId" component={PaymentDetailContainer} />
      </Route>
      <Route path="messaging">
        <IndexRoute component={MessagingDashboardContainer} />
        <Route path=":emailLogId" component={EmailLogDetailContainer}>
        </Route>
      </Route>
      <Route path="settings" component={AdminGuard}>
        <IndexRoute component={SettingListContainer} />
        <Route path=":settingId" component={SettingDetailContainer} />
      </Route>
      <Route path="administrators" component={AdminGuard}>
        <IndexRoute component={AdministratorListContainer} />
        <Route path="create" component={AdministratorCreateContainer} />
      </Route>
      <Route path="exports">
        <IndexRoute component={Exports} />
        <Route path="exports" component={Exports} />
      </Route>
      <Route path="provision-fee">
        <IndexRoute component={IsAdmin(ProvisionFeeWithdraw)} />
        <Route path="withdraw" component={IsAdmin(ProvisionFeeWithdraw)} />
      </Route>
      <Route path="help" component={AdminGuard}>
        <IndexRoute component={QuestionsContainer} />
        <Route path=":questionId" component={QuestionDetailContainer} />
      </Route>
      <Route path="encashmentStatusChange">
        <IndexRoute component={EncashmentStatus} />
        <Route path="encashmentStatusChange" component={EncashmentStatus} />
      </Route>
      <Route path="transactions">
        <IndexRoute component={IsAdmin(TransactionsContainer)} />
        <Route path="all" component={IsAdmin(TransactionsContainer)} />
        <Route path="pending" component={IsAdmin(PendingTransactionsContainer)} />
      </Route>
      <Route path="report" >
        <IndexRoute component={ReportTransactionsContainer} />
        <Route path="reportJob" component={ReportTransactionsContainer} />
      </Route>
      <Route path="file/:fileId" component={HandleFileDownloadContainer} />
    </Route>

    <Route path="cc" component={CallCentrumGuard}>
      <IndexRoute component={CallCentrumLandingContainer} />
      <Route path=":accountId" component={CallCentrumContainer} />
    </Route>

    <Route path="signout" >
      <Route path=":token/:mailName" component={NotificationSignOutContainer} />
    </Route>

    <Route path="*" component={NotFound} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/app/routes/index.js